module.exports = "/static/assets/954db77158548ee8654dc468c9b6ccb4.png";